import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import LookupGeneric from "./lookupGeneric";
import AreaOfStudyService from "../../src/Services/AreaOfStudy.service";
import AreaOfStudyTypeDomainService from "../../src/Domain/AreaOfStudyType/AreaOfStudyType.service";
const MinorLookup = (props) => {
    return LookupGeneric({
        onChange: props.onChange,
        defaultIds: props.defaultIds,
        fetchItemsById: (ids) => {
            return AreaOfStudyService.findByIds(
            // @ts-expect-error - TS2345 - Argument of type 'string[]' is not assignable to parameter of type 'number[]'.
            ids, AreaOfStudyTypeDomainService.MINOR_ID);
        },
        fetchOptions: (query) => {
            return AreaOfStudyService.search({
                query,
                areaOfStudyTypeIds: [AreaOfStudyTypeDomainService.MINOR_ID],
                active: true,
            }).then(({ data }) => data);
        },
        optionRenderer: function minorRenderer(minor) {
            return _jsx("span", { children: minor.name });
        },
    });
};
export default MinorLookup;
